import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import "./App.css";

function App() {
  const [services, setServices] = useState([]);
  const [serviceImages, setServiceImages] = useState({});

  useEffect(() => {
    const klasorler = [
      "audio", "aydinlatma", "boyler", "elektrik-ariza", "ev-elektrik",
      "guvenlik-kamera", "isyeri-elektrik", "klima", "tadilat"
    ];

    fetch("/image_json/services_meta.json")
      .then((res) => res.json())
      .then((metaData) => {
        Promise.all(
          klasorler.map((slug) =>
            fetch(`/image_json/${slug}.json`)
              .then((res) => res.json())
              .then((data) => {
                setServiceImages((prev) => ({ ...prev, [slug]: data }));
                const meta = metaData[slug] || {};
                return {
                  id: slug,
                  title: meta.title || slug,
                  description: meta.description || "",
                  short_desc: meta.short_desc || "",
                  icon: meta.icon || "🔧"
                };
              })
              .catch(() => ({
                id: slug,
                title: slug,
                description: "",
                short_desc: "",
                icon: "🔧"
              }))
          )
        ).then((serviceList) => {
          setServices(serviceList);
        });
      });
  }, []);

  return (
    <Router>
      <Routes>
        {/* Ana Sayfa */}
        <Route
          path="/"
          element={
            <HomePage
              services={services}
              serviceImages={serviceImages}
            />
          }
        />

        {/* Hizmet Detay Sayfası - İki farklı URL desteği */}
        <Route
          path="/service/:slug"
          element={
            <ServiceDetailPage
              services={services}
              serviceImages={serviceImages}
            />
          }
        />
        <Route
          path="/hizmet/:slug"
          element={
            <ServiceDetailPage
              services={services}
              serviceImages={serviceImages}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;